import React from 'react';
import { Table, Empty, Input, Form } from 'antd';
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, FORMAT_NUMBER_NO_ZERO } from '../../../../common/types/regularExpresionType';
import global from '../../../../common/utility/global';

export default function CierreSoles(props) {
    const _liStyle = {fontWeight:'bold'}

    return (
        <div>
            <Table
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.id}
                locale={{
                    emptyText:
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='No se encontraron datos'
                        />
                }}
                columns={[
                    {
                        title: 'Tipo',
                        dataIndex: 'formato',
                        key: 'formato',
                        align: 'center'
                    },
                    {
                        title: 'Denominación',
                        dataIndex: 'abreviatura',
                        key: 'abreviatura',
                        render: function(value,row) {
                         return (
                            <div>
                            {value}{row.monto}
                        </div>
                         )

                        }
                    },
        
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        render: (value, row) => {
                
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecioUnitario[${row.id}]`, {
                                        initialValue: parseFloat(value).toFixed(0),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Ingrese valor entero"
                                        }]
                                    })(
                                        <Input
                                            disabled={props.precioUnitarioDisabled}
                                            placeholder="Cantidad"
                                            autoComplete="off"
                                            className="text-right"
                                            onKeyPress={global.onKeyPressNumber}
                                            //onBlur={(e) => props.onCalculateDetail(row, "arrPrecioUnitario", e.target.value, 5)}
                                           onBlur={(e) => props.onCalculateDetail(row, "arrPrecioUnitario", e.target.value, 5)}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                
                    },
        
                 
                    {
                        title: 'Monto',
                        dataIndex: 'total',
                        key: 'total',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>S/ {data.toFixed(2)}</span>
                        )

                    },
          

                ]}

                footer={(e) =>  <span style={_liStyle}> TOTAL: S/  { e.reduce((a, b) => a + (b["total"] || 0), 0).toFixed(2)}</span>}

            />
        </div>
    );
}